<template>
    <div>
        <div class="flex justify-center w-full">
            <custom-tooltip bottom border>
                <app-button icon circle @click="openNewFilter">
                    <img
                        src="@/assets/images/filter.svg"
                        height="15"
                        width="15"
                        alt="reload img"
                    />
                </app-button>
                <template #tooltip> Modificar filtros de búsqueda </template>
            </custom-tooltip>
        </div>
        <div class="flex flex-col items-center">
            <div
                v-if="activeFilters.includes('phone')"
                class="md:w-7/12 w-8/12 mx-auto mt-2"
            >
                <custom-input
                    id="phone"
                    v-model="phone"
                    type="text"
                    name="phoneSearch"
                    label="Celular"
                    class="mr-2"
                    aria-label="phone"
                    :error="
                        introPhone && !isValidPhone
                            ? 'Ingrese número valido'
                            : ''
                    "
                    @blur="onBlurPhone"
                    @input="clearPhone"
                    @enter="onEnter"
                    @click-icon="onEnter"
                >
                    <template #icon> 📱 </template>
                </custom-input>
            </div>
            <div
                v-if="activeFilters.includes('email')"
                class="md:w-7/12 w-8/12 mx-auto mt-2"
            >
                <custom-input
                    id="email"
                    v-model="email"
                    type="text"
                    name="email"
                    label="Correo"
                    class="mr-2"
                    aria-label="Email"
                    :error="
                        introEmail && !isValidEmail
                            ? 'Ingrese correo valido'
                            : ''
                    "
                    @blur="onBlurEmail"
                    @enter="onEnter"
                    @click-icon="onEnter"
                    @input="lowerCaseEmail"
                >
                    <template #icon> ✉ </template>
                </custom-input>
            </div>

            <div
                v-if="activeFilters.includes('identificationNumber')"
                class="md:w-7/12 w-8/12 mx-auto mt-2"
            >
                <custom-input
                    id="document"
                    v-model="identificationNumber"
                    type="text"
                    name="document"
                    label="Número de documento"
                    class="mr-2"
                    aria-label="Document"
                    :error="
                        introIdentificationNumber &&
                        !isValidIdentificationNumber
                            ? 'Ingrese documento Valido'
                            : ''
                    "
                    @blur="onBlurIdentificationNumber"
                    @enter="onEnter"
                    @click-icon="onEnter"
                >
                    <template #icon> 🖋 </template>
                </custom-input>
            </div>
        </div>

        <app-dialog v-model="isOpenModal" size="lg" @close="pushNewFilter">
            <template #header>
                <div class="flex items-center justify-between gap-4">
                    <h3 class="text-base font-semibold text-theme-base">
                        Selecciona los filtros
                    </h3>

                    <app-button
                        :disabled="!filters.length"
                        @click="isOpenModal = false"
                    >
                        ✔️ Aplicar filtros ({{ filters.length }})
                    </app-button>
                </div>
            </template>
            <cards-selector v-model="filters" :base="$data.$baseFilters" />
        </app-dialog>
    </div>
</template>

<script>
import { usersFilters } from "@/common/fields/filters-query";
import {
    emailSimpleRegex,
    identificationNumberRegex,
    nameRegex,
    stringNumberRegex
} from "@/common/lib/regex";

import AppDialog from "@/components/utils/AppDialog.vue";
import CardsSelector from "@/components/utils/CardsSelector.vue";
import CustomInput from "@/components/utils/CustomInput.vue";

export default {
    name: "UsersFilters",
    components: {
        AppDialog,
        CardsSelector,
        CustomInput
    },
    model: {
        prop: "itemsCurrent",
        event: "change"
    },
    props: {
        itemsCurrent: {
            default: () => ({}),
            type: Object,
            require: true
        },
        enabledFilters: {
            default: () => ["email", "identificationNumber"],
            type: Array,
            require: true
        }
    },
    data: () => ({
        activeFilters: [""],
        isOpenModal: false,
        email: "",
        phone: "",
        lastName: "",
        firstName: "",
        identificationNumber: "",
        introEmail: false,
        introPhone: false,
        introLastName: false,
        introFirstName: false,
        introIdentificationNumber: false,
        filters: [""],
        $baseFilters: usersFilters
    }),
    computed: {
        isValidPhone() {
            return stringNumberRegex.test(this.phone);
        },
        isValidEmail() {
            return emailSimpleRegex.test(this.email);
        },
        isValidIdentificationNumber() {
            return identificationNumberRegex.test(this.identificationNumber);
        },
        isValidFirstName() {
            return nameRegex.test(this.firstName);
        },
        isValidLastName() {
            return nameRegex.test(this.lastName);
        }
    },
    watch: {
        filters() {
            this.applyFilter();
        },
        enabledFilters(value) {
            this.setEnabledFilters(value);
        }
    },
    mounted() {
        this.setEnabledFilters(this.enabledFilters);
        this.setInput(this.itemsCurrent);
        this.applyFilter();
    },
    methods: {
        setInput(value) {
            const filters = Object.keys(value);
            this.activeFilters = filters;
            this.filters = filters;
            if ("phone" in value) this.phone = value.phone;
            if ("email" in value) this.email = value.email;
            if ("identificationNumber" in value) {
                this.identificationNumber = value.identificationNumber;
            }
        },
        openNewFilter() {
            this.isOpenModal = true;
        },
        pushNewFilter() {
            this.activeFilters = [...this.filters];
            this.applyFilter();
        },
        applyFilter() {
            this.$emit("change", {
                ...{
                    ...(this.activeFilters.includes("phone") && this.phone
                        ? { phone: this.phone }
                        : null)
                },
                ...{
                    ...(this.activeFilters.includes("email")
                        ? { email: this.email }
                        : null)
                },
                ...{
                    ...(this.activeFilters.includes("identificationNumber") &&
                    this.identificationNumber
                        ? { identificationNumber: this.identificationNumber }
                        : null)
                }
            });
        },
        onEnter() {
            this.$emit("enter");
        },
        onBlurEmail() {
            this.introEmail = true;
            this.applyFilter();
        },
        onBlurPhone() {
            this.introPhone = true;
            this.applyFilter();
        },
        onBlurIdentificationNumber() {
            this.introIdentificationNumber = true;
            this.applyFilter();
        },
        lowerCaseEmail() {
            this.email = this.email.toLowerCase();
        },
        setEnabledFilters(value) {
            this.baseFilters = usersFilters.filter((item) => {
                const hasPermission =
                    !item.permissions ||
                    item.permissions.every((permission) =>
                        this.$ability.hasPermission(permission)
                    );
                return value.includes(item.id) && hasPermission;
            });
        },
        clearPhone() {
            this.phone = this.phone.trim().replace(/\s+/g, "");
        }
    }
};
</script>
